const TOPIC_PROMOTION_DATA_FEATURE_ORDER_WITH_SIMILAR_COMBOS = 4;
const TOPIC_PROMOTION_DATA_FEATURE_ORDER_WITHOUT_SIMILAR_COMBOS = 3;
const TOPIC_PROMOTION_DATA_FEATURE_ORDER_WITHOUT_TILES = 2;

export default function initTopicPromoTracking(_document) {
	const topicPromotionContainer = _document.getElementById("topicPromotionContainer");

	const tilesSections = Array.from(_document.getElementsByTagName("section")).filter(
		section =>
			section.className.includes("combo_presentation-additional_combos") ||
			section.className.includes("combo_presentation-similar_combos")
	);
	const thereAreAnyTypeOfTiles = tilesSections && tilesSections.length > 0;
	const thereAreSimilarCombosInTheSecondPosition =
		tilesSections.length > 1 && tilesSections[1].className.includes("combo_presentation-similar_combos");
	if (thereAreAnyTypeOfTiles) {
		topicPromotionContainer.dataset.featureOrder = thereAreSimilarCombosInTheSecondPosition
			? TOPIC_PROMOTION_DATA_FEATURE_ORDER_WITH_SIMILAR_COMBOS
			: TOPIC_PROMOTION_DATA_FEATURE_ORDER_WITHOUT_SIMILAR_COMBOS;
	} else {
		topicPromotionContainer.dataset.featureOrder = TOPIC_PROMOTION_DATA_FEATURE_ORDER_WITHOUT_TILES;
	}
}
